import { Box, Button, Tooltip } from "@mui/material";
import { PRETTY_BLUE } from "./BorderWithLabel";

type ToggleProps = {
    value: boolean,
    setValue: React.Dispatch<React.SetStateAction<boolean>>,
    labelTrue: string,
    labelFalse: string,
    tooltipFalse?: string,
    tooltipTrue?: string,
};

const Toggle = ( {
    value,
    setValue,
    labelTrue,
    labelFalse,
    tooltipFalse,
    tooltipTrue,
}: ToggleProps ) =>
{
    const hoverColor = "rgba(255,255,255,0.4)";
    const unselectedColor = "white";//"transparent";
    const selectedColor = "#f2f8fc";//"white";
    const switchBackground = "transparent";//prettyBlue;//"#0d4883";
    const selectedFont = PRETTY_BLUE;
    const unselectedFont = "grey";
    const curvedCorner = "5px";
    const squareCorner = "0px";
    const selectedWidth = "2px";
    const unselectedWidth = "1px";
    const selectedBorder = selectedWidth + " solid " + selectedFont;
    const unselectedBorder = unselectedWidth + " solid " + unselectedFont;
    return (
        <Box
            sx = {{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: switchBackground,
                borderRadius: "8px",
                padding: "4px",
                width: "100%",
            }}
        >
            <Tooltip title = {tooltipTrue}>
                <Button
                    onClick = {() => setValue( false )}
                    variant = "outlined"
                    sx = {{
                        flex: 1,
                        borderWidth: ( !value ? selectedWidth : unselectedWidth ),
                        border: ( !value ? selectedBorder : unselectedBorder ),
                        borderTopLeftRadius: curvedCorner,
                        borderBottomLeftRadius: curvedCorner,
                        borderTopRightRadius: squareCorner,
                        borderBottomRightRadius: squareCorner,
                        backgroundColor: !value ? selectedColor : unselectedColor,
                        color: !value ? selectedFont : unselectedFont,
                        fontWeight: !value ? "bold" : "",
                        textTransform: "none",
                        "&:hover": {
                            backgroundColor: !value ? selectedColor : hoverColor,
                            borderWidth: selectedWidth
                        },
                    }}
                >
                    {labelFalse}
                </Button>
            </Tooltip>
            <Tooltip title = {tooltipFalse}>
                <Button
                    onClick = {() => setValue( true )}
                    variant = "outlined"
                    sx = {{
                        flex: 1,
                        backgroundColor: value ? selectedColor : unselectedColor,
                        border: ( value ? selectedBorder : unselectedBorder ),
                        borderTopLeftRadius: squareCorner,
                        borderBottomLeftRadius: squareCorner,
                        borderTopRightRadius: curvedCorner,
                        borderBottomRightRadius: curvedCorner,
                        color: value ? selectedFont : unselectedFont,
                        fontWeight: value ? "bold" : "",
                        textTransform: "none",
                        "&:hover": {
                            backgroundColor: value ? selectedColor : hoverColor,
                            borderWidth: selectedWidth
                        },
                    }}
                >
                    {labelTrue}
                </Button>
            </Tooltip>
        </Box>
    );
};

export default Toggle;
